/*eslint-disable*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

// core components

function Pricing() {
  return (
    <>
      <div className="section section-pricing" id="sectionBuy">
        <Container>
          <div className="our-clients">
            <Container>
              <Row>
                <Col className="ml-auto" md="2">
                  <img
                    alt="..."
                    src={require("assets/img/presentation-page/pres52.png")}
                  ></img>
                </Col>
                <Col md="2">
                  <img
                    alt="..."
                    src={require("assets/img/presentation-page/pres32.png")}
                  ></img>
                </Col>
                <Col md="2">
                  <img
                    alt="..."
                    src={require("assets/img/presentation-page/pres26.png")}
                  ></img>
                </Col>
                <Col className="mr-auto" md="2">
                  <img
                    alt="..."
                    src={require("assets/img/presentation-page/pres45.png")}
                  ></img>
                </Col>
              </Row>
            </Container>
          </div>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="8">
              <h2 className="title">Ready to move forward with Tenfinney?</h2>
            </Col>
            <Col className="text-center ml-auto mr-auto" md="8">
              <Button
                color="info"
                target="_blank"
                href="https://twitter.com/tenfinney"
              >
                Web3 Fractal Shop
              </Button>
              <Button
                color="neutral"
                target="_blank"
                href="https://bafybeibu35q4duqpfp2xu2xucwa6iwog6fpqysb7ao7hua44lcx5sunwlm.ipfs.infura-ipfs.io/"
              >
                See Demo
              </Button>
            </Col>
            <Col className="text-center ml-auto mr-auto mt-5" md="8">
              <h3>Contact information:</h3>
            </Col>
            <Col className="text-center ml-auto mr-auto" md="8">
              <Button
                className="btn-icon btn-round mr-1"
                color="twitter"
                id="tooltip477589936"
                size="lg"
              >
                <i className="fab fa-twitter"></i>
              </Button>
              <UncontrolledTooltip delay={0} target="tooltip477589936">
              Send a message.
              </UncontrolledTooltip>
              <Button
                className="btn-round btn-icon mr-1"
                color="linkedin"
                id="tooltip129912781"
                size="lg"
              >
                <i className="fab fa-linkedin"></i>
              </Button>
              <UncontrolledTooltip delay={0} target="tooltip129912781">
              Experience.
              </UncontrolledTooltip>
              <Button
                className="btn-round btn-icon"
                color="github"
                href="https://github.com/tenfinney"
                target="_blank"
                id="tooltip156844414"
                size="lg"
              >
                <i className="fab fa-github"></i>
              </Button>
              <UncontrolledTooltip delay={0} target="tooltip156844414">
                See Code
              </UncontrolledTooltip>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Pricing;
